import _asyncToGenerator from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/JG/jg/IWMS5.0/SRM/GIT/SRM.VUE/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import '@/components/d2-icon/font-awesome-4.7.0/css/font-awesome.min.css';
import localeMixin from '@/locales/mixin.js';
import dayjs from 'dayjs';
import { mapActions } from 'vuex';
import log from '@/libs/util.log';
export default {
  mixins: [localeMixin],
  mounted: function mounted() {
    var _this = this;

    this.timeInterval = setInterval(function () {
      _this.refreshTime();
    }, 1000);
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.timeInterval);
  },
  data: function data() {
    return {
      timeInterval: null,
      // 表单
      formLogin: {
        username: '',
        password: ''
      },
      loading: false
    };
  },
  methods: _objectSpread(_objectSpread({}, mapActions('d2admin/account', ['login'])), {}, {
    refreshTime: function refreshTime() {
      this.time = dayjs().format('HH:mm:ss');
    },
    // 提交登录信息
    submit: function submit() {
      var _this2 = this;

      this.$refs.loginForm.validate( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(bool) {
          var userName, password, res;
          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (!(bool === true)) {
                    _context.next = 8;
                    break;
                  }

                  _this2.loading = true;
                  userName = _this2.formLogin.username;
                  password = _this2.formLogin.password;
                  _context.next = 6;
                  return _this2.login({
                    userName: userName,
                    password: password
                  });

                case 6:
                  res = _context.sent;

                  // console.log('res',res);
                  if (res.code === 0) {
                    _this2.$message.success('登录成功');

                    _this2.$router.push('/index');

                    _this2.loading = false;
                  } else {
                    _this2.loading = false;

                    _this2.$message.warning(res.message);
                  }

                case 8:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }),
  computed: {
    rules: function rules() {
      return {
        username: [{
          required: true,
          message: this.$t('page.login.tips.username'),
          trigger: 'blur'
        }],
        password: [{
          required: true,
          message: this.$t('page.login.tips.password'),
          trigger: 'blur'
        }]
      };
    },
    formValidateError: function formValidateError() {
      return this.$t('page.login.tips.formValidateError');
    }
  }
};